export default __webpack_public_path__ + "static/media/electrician.8380bf69.jpg";